import { defineStore } from "pinia";

interface IAppState {
  appThemeClass: string;
  appDarkMode: boolean;
  appHeaderHide: boolean;
  appHeaderFixed: boolean;
  appHeaderInverse: boolean;
  appHeaderSearchToggled: boolean;
  appHeaderLanguageBar: boolean;
  appHeaderMegaMenu: boolean;
  appHeaderHover: boolean;
  appSidebarTwo: boolean;
  appSidebarHide: boolean;
  appSidebarEnd: boolean;
  appSidebarWide: boolean;
  appSidebarLight: boolean;
  appSidebarFixed: boolean;
  appSidebarCollapsed: boolean;
  appSidebarMobileToggled: boolean;
  appSidebarMobileClosed: boolean;
  appSidebarMinified: boolean;
  appSidebarHover: boolean;
  appSidebarSearch: boolean;
  appSidebarToggled: boolean;
  appSidebarEndToggled: boolean;
  appSidebarEndMobileToggled: boolean;
  appSidebarTransparent: boolean;
  appSidebarGrid: boolean;
  appGradientEnabled: boolean;
  appTopMenu: boolean;
  appContentFullHeight: boolean;
  appContentClass: string;
  appFooter: boolean;
  appFooterFixed: boolean;
  appThemePanelToggled: boolean;
  appBoxedLayout: boolean;
  appSelectedMenu: string;
  appSelectedMenuIcon: string;
  appCompany: string;
  appApiURL: string;
  appGoBack: boolean;
}

export const useAppOptionStore = defineStore("appOption", {
  state: (): IAppState => ({
    appThemeClass: "",
    appDarkMode: false,
    appHeaderHide: true,
    appHeaderFixed: true,
    appHeaderInverse: false,
    appHeaderSearchToggled: false,
    appHeaderLanguageBar: false,
    appHeaderMegaMenu: false,
    appHeaderHover: false,
    appSidebarTwo: false,
    appSidebarHide: true,
    appSidebarEnd: false,
    appSidebarWide: false,
    appSidebarLight: false,
    appSidebarFixed: true,
    appSidebarCollapsed: false,
    appSidebarMobileToggled: false,
    appSidebarMobileClosed: false,
    appSidebarMinified: false,
    appSidebarHover: false,
    appSidebarSearch: false,
    appSidebarToggled: false,
    appSidebarEndToggled: false,
    appSidebarEndMobileToggled: false,
    appSidebarTransparent: false,
    appSidebarGrid: false,
    appGradientEnabled: false,
    appTopMenu: false,
    appContentFullHeight: false,
    appContentClass: "",
    appFooter: false,
    appFooterFixed: false,
    appThemePanelToggled: false,
    appBoxedLayout: false,
    appSelectedMenu: "",
    appSelectedMenuIcon: "",
    appCompany: "",
    appApiURL: "",
    appGoBack: false,
  }),
  persist: true, // ✅ Asegura que esto está dentro del objeto de opciones
});
